import formatDate from "../helpers/date";
import decodeHtml from "../helpers/decode";

function Card(hit, helpers, defaults) {
	const { html, components, sendEvent } = helpers;

	if (hit._highlightResult && hit._highlightResult.post_title && hit._highlightResult.post_title.value) {
		// decode the highlighted title
		hit._highlightResult.post_title.value = decodeHtml(hit._highlightResult.post_title.value);
	}

	let image = hit.images.full && hit.images.full.url;
	let imageAlt = hit.images.full && hit.featured_image_alt;
	if ( ! image ) {
		if ( defaults.images[hit.post_type] ) {
			image = defaults.images[hit.post_type].src;
			imageAlt = defaults.images[hit.post_type].alt;
		}
	}
	let authors = '';
	let author_field = hit.taxonomies.person_tax;
	if (Array.isArray(hit.authors)) { // TODO: can remove this check once all posts have been reindexed, and set author_field = hit.authors
		author_field = hit.authors;
	}
	if (Array.isArray(author_field)) {
		authors = author_field.map((author) => {
			return author;
		}).join(', ');
	}

	let formattedDate = hit.post_date_formatted;
	if ( 'book' === hit.post_type ) {
		formattedDate = formatDate(hit.post_date, 'long');
	}
	
	const typesWithMeta = [
		'news',
		'article',
		'book',
		'collection'
	];

	// const permalink = hit.permalink;
	const permalink = hit.permalink.replace('preview.brookings.edu', 'www.brookings.edu');
	const is_external = ! permalink.includes('brookings');

	let articleClasses = '';
	if (Array.isArray(hit.content_type) && hit.content_type.length) {
		articleClasses = hit.content_type.map((type) => {
			return type.toLowerCase();
		}).join(' ');
	}

	const extraMeta = hit.publication_source ? html`<span class="publication">${decodeHtml(hit.publication_source)}</span> | ` : '';
	
	return html `
	<article class="article ${hit.post_type} group article-feed ${articleClasses}">
		<a href="${permalink}" target="${is_external ? '_blank' : '_self'}" class="overlay-link">
			<span class="sr-only">${hit.post_title}</span>
		</a>
		${image && 
			html`
				<div class="img-wrapper">
					<figure>
						<img src="${image}?w=500" alt="${hit.featured_image && hit.featured_image.alt ? hit.featured_image.alt : ''}" style="${hit.featured_image && hit.featured_image.focus ? hit.featured_image.focus : ''}" />
						<div
							class="overlay group-hover:opacity-100"
						></div>
					</figure>
				</div>`
		}
		<div class="article-insert">
			<span class="article-type">
			${decodeHtml(hit.primary_topic)}
			</span>
			<span class="article-insert-details">
				<span class="article-title group-hover:text-link-underline-hovered">
				${components.Highlight({ hit, attribute: 'post_title' })}
				${ is_external &&
					html`<span class="external-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="external / thick">
							<path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd" d="M5.99995 6H16H18V8V18H16V9.61632L6.69925 18.7148L5.30066 17.2852L14.7922 8H5.99995V6Z" fill="black"/>
							</g>
						</svg>
					</span>`
				}
				</span>
				${typesWithMeta.includes(hit.post_type) &&
					html`<span class="meta">
						<p class="byline">
							${decodeHtml(authors)}
						</p>
						<p class="date">
						${extraMeta}
						${formattedDate}
						</p>
					</span>`
				}
				<p class="hit-text">${components.Snippet({ hit, attribute: 'content' })}</p>
			</span>
		</div>
	</article>
	`;
}

export default Card;
